export default __webpack_public_path__ + "static/media/Levitate D4.2 Definition of Desirable Scenarios.6663a457.pdf";